import axios from 'axios';
import {
    GET_DRIVER_PROFILE,
    UPDATE_INPUT_DRIVER_PROFILE,
    UPDATE_INPUT_CV_DRIVER_PROFILE,
    SUBMIT_DRIVER_PROFILE,
    LOAD_CITY_SELECT_OPTIONS,
} from './types';
import {
    submitDriverProfileToFirebase,
    getDriverProfileFromFirebase,
} from '../helpers/firebase';

export const defaultDriverProfile = {
    name: null,
    lastName: null,
    age: null,
    city: null,
    telephoneNumber: null,
    licenceFromYear: null,
    lifetimeKm: null,
    knowBratislava: null,
    criminalRecord: null,
    contractType: null,
    fbLink: null,
    uberExperience: null,
    cv: {
        url: null,
        extension: null,
    },
    hasOwnCar: false,
};

export async function getDriverProfile() {
    const data = await getDriverProfileFromFirebase();

    return {
        type: GET_DRIVER_PROFILE,
        payload: data ? data : defaultDriverProfile,
    };
}

export function updateInput(data, name) {
    let obj = {};
    obj[name] = data;

    return {
        type: UPDATE_INPUT_DRIVER_PROFILE,
        payload: obj,
    };
}

export function updateInputCv(cvFile, extension) {
    return {
        type: UPDATE_INPUT_CV_DRIVER_PROFILE,
        payload: {
            "cv": {
                url: cvFile,
                extension: extension,
            },
        },
    };
}

export function submitDriverProfile(driverProfile) {
    const result = submitDriverProfileToFirebase(driverProfile);

    return {
        type: SUBMIT_DRIVER_PROFILE,
        payload: driverProfile,
    };
}

export async function loadCitySelectOptions(input) {
    if (!input)
        input = "";

    const request = await axios.get(`https://secure.geonames.org/search?country=SK&username=yimejky&type=json&featureClass=P&name_startsWith=${input}`);

    const data = request.data.geonames;

    const options = data.map((item) => {
        return {
            value: item.toponymName,
            label: item.toponymName
        };
    });

    return {
        type: LOAD_CITY_SELECT_OPTIONS,
        payload: options,
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/driver_profile_actions.js